module.exports = __webpack_public_path__ + "static/media/signage-indoor-img44.9574cd40.jpg";